{
  "_meta": {
    "comment": "ISO-3166 alpha-2 (lowercase) -> zone code. Four zones: AF (Afrique), EU (Europe), AS (Asie & Océanie), AM (Amériques). Transcontinental countries assigned to a single one. Ignored at load (the _ prefix).",
    "transcontinental": {
      "ru": "EU (Russia spans Europe/Asia -> Europe)",
      "tr": "AS (Turkey spans Europe/Asia -> Asia)",
      "kz": "AS (Kazakhstan spans Europe/Asia -> Asia)",
      "az": "AS (Azerbaijan -> Asia)",
      "ge": "AS (Georgia, Caucasus -> Asia)",
      "am": "AS (Armenia, Caucasus -> Asia)",
      "cy": "EU (Cyprus, EU member -> Europe)",
      "eg": "AF (Egypt spans Africa/Asia via Sinai -> Africa)"
    }
  },
  "ad": "EU", "ae": "AS", "af": "AS", "ag": "AM", "al": "EU",
  "am": "AS", "ao": "AF", "ar": "AM", "at": "EU", "au": "AS",
  "az": "AS", "ba": "EU", "bb": "AM", "bd": "AS", "be": "EU",
  "bf": "AF", "bg": "EU", "bh": "AS", "bi": "AF", "bj": "AF",
  "bn": "AS", "bo": "AM", "br": "AM", "bs": "AM", "bt": "AS",
  "bw": "AF", "by": "EU", "bz": "AM", "ca": "AM", "cd": "AF",
  "cf": "AF", "cg": "AF", "ch": "EU", "ci": "AF", "cl": "AM",
  "cm": "AF", "cn": "AS", "co": "AM", "cr": "AM", "cu": "AM",
  "cv": "AF", "cy": "EU", "cz": "EU", "de": "EU", "dj": "AF",
  "dk": "EU", "dm": "AM", "do": "AM", "dz": "AF", "ec": "AM",
  "ee": "EU", "eg": "AF", "er": "AF", "es": "EU", "et": "AF",
  "fi": "EU", "fj": "AS", "fm": "AS", "fr": "EU", "ga": "AF",
  "gb": "EU", "gd": "AM", "ge": "AS", "gh": "AF", "gm": "AF",
  "gn": "AF", "gq": "AF", "gr": "EU", "gt": "AM", "gw": "AF",
  "gy": "AM", "hn": "AM", "hr": "EU", "ht": "AM", "hu": "EU",
  "id": "AS", "ie": "EU", "il": "AS", "in": "AS", "iq": "AS",
  "ir": "AS", "is": "EU", "it": "EU", "jm": "AM", "jo": "AS",
  "jp": "AS", "ke": "AF", "kg": "AS", "kh": "AS", "ki": "AS",
  "km": "AF", "kn": "AM", "kp": "AS", "kr": "AS", "kw": "AS",
  "kz": "AS", "la": "AS", "lb": "AS", "lc": "AM", "li": "EU",
  "lk": "AS", "lr": "AF", "ls": "AF", "lt": "EU", "lu": "EU",
  "lv": "EU", "ly": "AF", "ma": "AF", "mc": "EU", "md": "EU",
  "me": "EU", "mg": "AF", "mh": "AS", "mk": "EU", "ml": "AF",
  "mm": "AS", "mn": "AS", "mr": "AF", "mt": "EU", "mu": "AF",
  "mv": "AS", "mw": "AF", "mx": "AM", "my": "AS", "mz": "AF",
  "na": "AF", "ne": "AF", "ng": "AF", "ni": "AM", "nl": "EU",
  "no": "EU", "np": "AS", "nr": "AS", "nz": "AS", "om": "AS",
  "pa": "AM", "pe": "AM", "pg": "AS", "ph": "AS", "pk": "AS",
  "pl": "EU", "pt": "EU", "pw": "AS", "py": "AM", "qa": "AS",
  "ro": "EU", "rs": "EU", "ru": "EU", "rw": "AF", "sa": "AS",
  "sb": "AS", "sc": "AF", "sd": "AF", "se": "EU", "sg": "AS",
  "si": "EU", "sk": "EU", "sl": "AF", "sm": "EU", "sn": "AF",
  "so": "AF", "sr": "AM", "ss": "AF", "st": "AF", "sv": "AM",
  "sy": "AS", "sz": "AF", "td": "AF", "tg": "AF", "th": "AS",
  "tj": "AS", "tl": "AS", "tm": "AS", "tn": "AF", "to": "AS",
  "tr": "AS", "tt": "AM", "tv": "AS", "tz": "AF", "ua": "EU",
  "ug": "AF", "us": "AM", "uy": "AM", "uz": "AS", "vc": "AM",
  "ve": "AM", "vn": "AS", "vu": "AS", "ws": "AS", "ye": "AS",
  "za": "AF", "zm": "AF", "zw": "AF"
}
